// src/components/AccountInfo.js
import React, { useEffect, useState } from 'react';
import { useTranslation } from '../i18n/i18n';
import { Container, Paper, Typography, Box, Button, CircularProgress, Divider, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import API_ENDPOINTS from '../config/apiConfig';

function AccountInfo() {
  const { t } = useTranslation();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await fetch(`${API_ENDPOINTS.BASEURL}/api/user/me`, { credentials: 'include' });
        if (res.ok) {
          const data = await res.json();
          setUser(data);
        }
      } catch (err) {
        // handle error
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

  if (loading) {
    return (
      <Container maxWidth="sm" sx={{ mt: 6, textAlign: 'center' }}>
        <CircularProgress />
        <Typography variant="h6" sx={{ mt: 2 }}>{t('account_loading')}</Typography>
      </Container>
    );
  }

  if (!user) {
    return (
      <Container maxWidth="sm" sx={{ mt: 6, textAlign: 'center' }}>
        <Typography variant="h6" color="error">{t('account_error')}</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 6 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <IconButton onClick={() => navigate('/dashboard')} sx={{ mr: 1 }} aria-label="back to dashboard">
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h5" sx={{ fontWeight: 600 }}>{t('account_title')}</Typography>
        </Box>
        <Divider sx={{ mb: 2 }} />
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle1"><b>{t('name')}:</b> {user.name || '-'}</Typography>
          <Typography variant="subtitle1"><b>{t('email')}:</b> {user.email}</Typography>
          <Typography variant="subtitle1"><b>{t('role')}:</b> {user.role}</Typography>
          <Typography variant="subtitle1"><b>Status:</b> {user.status}</Typography>
        </Box>
        <Button variant="contained" color="primary" onClick={() => navigate('/change-password')}>
          {t('change_password')}
        </Button>
      </Paper>
    </Container>
  );
}

export default AccountInfo;
